/* IT HIPPIE — carrousel upsell du panier : interactions (chargé une fois par page).

   1. Pont tactile pour le « + » du carrousel (mobile).
      Sur iOS, quand le tiroir est ouvert, le verrou de scroll supprime le clic synthétique
      du tap → on déclenche le bouton nous-mêmes au touchend.
      17 oct. : on ne déclenche QUE sur un vrai tap (doigt quasi immobile, appui court).
      Avant, faire glisser le carrousel et lever le doigt sur un « + » ouvrait le pop-up.

   2. Ajout « fluide » depuis le pop-up d'ajout rapide quand le tiroir est ouvert
      (pas d'effet fermeture / réouverture du tiroir).

   3. Les clics dans les pop-ups d'ajout rapide / M'avertir / guide des tailles ne
      remontent pas jusqu'au tiroir (sinon le tiroir croit à un clic « à l'extérieur »
      et se ferme derrière le pop-up).

   2 et 3 étaient écrits en ligne dans snippets/cart-bijoux-upsell.liquid : ils ne
   s'exécutaient pas après un rafraîchissement AJAX du tiroir. */
(function () {
  if (window.__cpbUpsellTapBridge) return;
  window.__cpbUpsellTapBridge = true;

  /* ---------- 1. Tap vs glissement ---------- */
  var TAP_MOVE = 10;   // px
  var TAP_TIME = 500;  // ms
  var start = null;

  document.addEventListener('touchstart', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cpb-upsell__card .ith-qa-btn') : null;
    if (!btn || !e.touches || !e.touches[0]) { start = null; return; }
    start = { btn: btn, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cpb-upsell__card .ith-qa-btn') : null;
    if (!btn) return;
    var s = start;
    start = null;
    var tch = e.changedTouches && e.changedTouches[0];
    var isTap = s && s.btn === btn && tch &&
      Math.abs(tch.clientX - s.x) < TAP_MOVE &&
      Math.abs(tch.clientY - s.y) < TAP_MOVE &&
      (Date.now() - s.t) < TAP_TIME;
    if (!isTap) return; // glissement du carrousel : on laisse faire
    e.preventDefault();
    e.stopPropagation();
    btn.click();
  }, { passive: false });

  document.addEventListener('touchcancel', function () { start = null; }, { passive: true });

  /* ---------- 2. Ajout fluide depuis le pop-up, tiroir ouvert ---------- */
  var releaseTimer = null, obs = null;

  function unpin() {
    document.documentElement.classList.remove('cpb-smooth-add');
    if (obs) { try { obs.disconnect(); } catch (e) {} obs = null; }
    if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = null; }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var atc = (t && t.closest) ? t.closest('.ithqa__atc') : null;
    if (!atc) return;
    var cd = document.querySelector('cart-drawer');
    if (!cd || !cd.classList.contains('is-visible')) return;

    document.documentElement.classList.add('cpb-smooth-add');
    if (obs) { try { obs.disconnect(); } catch (e2) {} }

    obs = new MutationObserver(function () {
      if (releaseTimer) clearTimeout(releaseTimer);
      releaseTimer = setTimeout(unpin, 450);
    });
    try { obs.observe(cd, { childList: true, subtree: true }); } catch (e3) {}

    if (releaseTimer) clearTimeout(releaseTimer);
    releaseTimer = setTimeout(unpin, 3000);
  }, true);

  /* ---------- 3. Clics dans les pop-ups : ne pas fermer le tiroir ---------- */
  function bindPopupGuard() {
    document.body.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.ithqa, .ith-bis, .ithqa-guide')) {
        e.stopPropagation();
      }
    });
  }
  if (document.body) bindPopupGuard();
  else document.addEventListener('DOMContentLoaded', bindPopupGuard);
})();
